import type { postStatsExperimentRequest } from '@lt/api/dist/methods/stats/types';
import { createAction } from '@reduxjs/toolkit';

export interface sendExperimentResultType {
  experiment: postStatsExperimentRequest['experiment'];
  event: postStatsExperimentRequest['event'];
}

export const sendExperimentResultAction =
  createAction<sendExperimentResultType>(
    'experimentStats/sendExperimentResult',
  );
